import { useContext } from 'react';
import List from '@pelckmans/elementis/components/list';
import ChapterIcon from '@pelckmans/elementis/icons/chapter';
import { useTranslation } from 'react-i18next';
import ModuleContext from '../../_contexts/ModuleContext';
import { SearchResultSlideSet } from './../api/search-api';
import Pill from '@pelckmans/elementis/components/pill';
import { getFullHierarchyDescriptionOfNode } from '../../../../utils/getNodeDescription';
import Avatar from '@pelckmans/elementis/components/avatar';
import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import { buildGroupProps } from '../../../../utils/elementisUtils';
import useLicenses from '../../../../hooks/useLicenses';
import stripHtml from '../../../../utils/wordlist/stripHtml';
import useSlideSets from '../../hooks/useSlideSets';
import IdentityContext from '../../../../contexts/IdentityContext';

interface Props {
  searchItem: SearchResultSlideSet;
}

function SearchResultSlideSetItem({ searchItem }: Props) {
  const { allModules } = useContext(ModuleContext);
  const { t } = useTranslation();
  const { buildDoceoUrl } = useSlideSets();
  const { isModuleLicensed } = useLicenses();
  const {
    identity: { userId },
  } = useContext(IdentityContext);

  const targetModule = allModules.find(m => m.id === searchItem.moduleId);

  if (!targetModule) return null;
  const licensedModule = isModuleLicensed(targetModule);

  const { hierarchy } = searchItem;
  return (
    <List.Item
      key={searchItem.id}
      as="link"
      title={!licensedModule ? stripHtml(searchItem.name) : searchItem.name}
      disabled={!licensedModule}
      href={buildDoceoUrl({ id: Number(searchItem.id) })}
      target="_blank"
      rel="noopener noreferrer"
      pillGroupProps={buildGroupProps(
        <>
          <Pill key="scope-pill">{t('PAGES.SEARCH.RESULTS.SLIDE_SET')}</Pill>
          <Pill
            key="module-pill"
            size="sm"
            avatar={
              <Avatar>
                <AvatarImage size="xs" name={targetModule!.niceName} src={targetModule!.styling?.logo || ''} />
              </Avatar>
            }
          >
            {targetModule?.niceName}
          </Pill>
          <Pill key="hierarchy-pill" icon={<ChapterIcon />}>
            {getFullHierarchyDescriptionOfNode(hierarchy, t)}
          </Pill>
          {!searchItem.sharedWithUser && searchItem.owner === userId && (
            <Pill key="content-type-pill">{t('CONTENT_TYPE_DESCRIPTIONS.OWN_MATERIAL')}</Pill>
          )}
          {searchItem.sharedWithUser && (
            <Pill key="content-type-pill">{t('CONTENT_TYPE_DESCRIPTIONS.SHARED_MATERIAL')}</Pill>
          )}
        </>,
      )}
    />
  );
}

export default SearchResultSlideSetItem;
